module.exports = __webpack_public_path__ + "img/任意角度2.aa3bb99d.svg";